<ion-content [fullscreen]="true"
  ><ion-qc-csi
    [startingPageConfiguration]="startingPageConfiguration"
  ></ion-qc-csi>
</ion-content>
